import React from 'react';
import { Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import ModalDlg from 'components/Basic/ModalDlg';

type RaffleImagePreviewModalProps = {
  title: string;
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

const RaffleImagePreviewModal: React.FC<RaffleImagePreviewModalProps> = ({ title, visible, onClose, children }) => {
  return (
    <ModalDlg className="raffle_image_preview_modal" visible={visible} width={560} handleCancel={onClose} isCenter>
      <div className="raffle_image_preview_modal__content">
        <div className="raffle_image_preview_modal__header">
          <p className="raffle_image_preview_modal__title">{title}</p>
        </div>
        {children}
        <div className="raffle_image_preview_modal__footer">
          <Button className="raffle_image_preview_modal__close" onClick={onClose}>
            <FormattedMessage id="Close" />
          </Button>
        </div>
      </div>
    </ModalDlg>
  );
};

export default RaffleImagePreviewModal;
